export const UI_MODAL_OPEN = 'UI_MODAL_OPEN';
export const UI_MODAL_CLOSE = 'UI_MODAL_CLOSE';

export const UI_SET_ACTIVE_MAIN_TAXON = 'UI_SET_ACTIVE_MAIN_TAXON';

export const UI_SET_BACKGROUND = 'UI_SET_BACKGROUND';

export const UI_SET_MAIN_TAXON_DROPDOWN_VISIBILITY = 'UI_SET_MAIN_TAXON_DROPDOWN_VISIBILITY';

export const BG_HOMEPAGE = {type: 'background', path: 'homepage'};
export const BG_DEFAULT = {type: 'background', path: 'default'};

const initialState = {
  modal: {},
  background: BG_DEFAULT,
  activeMainTaxon: process.env.PRIMARY_TAXON,
  mainTaxonDropdownVisibility: false
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case UI_MODAL_OPEN:
      return {
        ...state,
        modal: payload
      };
    case UI_MODAL_CLOSE:
      return {
        ...state,
        modal: {}
      };
    case UI_SET_ACTIVE_MAIN_TAXON:
      return {
        ...state,
        activeMainTaxon: payload
      };
    case UI_SET_BACKGROUND:
      return {
        ...state,
        background: payload
      };
    case UI_SET_MAIN_TAXON_DROPDOWN_VISIBILITY:
      return {
        ...state,
        mainTaxonDropdownVisibility: payload
      };
    default:
      return state;
  }
}

export function openModal(ModalComponent, data = null) {
  return {type: UI_MODAL_OPEN, payload: {name: ModalComponent.modalName, data}};
}

export function closeModal() {
  return {type: UI_MODAL_CLOSE};
}

export function setActiveMainTaxon(activeMainTaxon) {
  return {type: UI_SET_ACTIVE_MAIN_TAXON, payload: activeMainTaxon};
}

export function setBackground(background = BG_DEFAULT) {
  return {type: UI_SET_BACKGROUND, payload: background};
}

export function setMainTaxonDropdownVisibility(mainTaxonDropdownVisibility) {
  return {type: UI_SET_MAIN_TAXON_DROPDOWN_VISIBILITY, payload: mainTaxonDropdownVisibility};
}



// WEBPACK FOOTER //
// ./ducks/ui.js